// // LmiaCheck.tsx
// import React, { useState } from 'react';

// const LmiaCheck: React.FC = () => {
//     const [showIframe, setShowIframe] = useState(false);
//     const toggleIframe = () => setShowIframe(!showIframe);

//     return (
//         <div>
//             <button onClick={toggleIframe} style={{
//                 backgroundColor: '#4CAF50', /* Green */
//                 border: 'none',
//                 color: 'white',
//                 padding: '10px',
//                 textAlign: 'center',
//                 textDecoration: 'none',
//                 display: 'inline-block',
//                 fontSize: '16px',
//                 margin: '4px 2px',
//                 cursor: 'pointer',
//                 borderRadius: '5px',
//                 fontWeight: 'bold'
//             }}>
//                 {showIframe ? 'Conceal LMIA Companies' : 'Discover Positive LMIA Companies'}
//             </button>


//             {showIframe && (

//                 <div style={{ position: 'relative', width: '100%', height: '720px', overflow: 'hidden', display: 'flex', justifyContent: 'center' }}>
//                     {showIframe && (
//                         <>
//                             <iframe
//                                 src="https://fastcheck-lmia.vercel.app/"
//                                 title="FastCheck: LMIAs"
//                                 width="100%" // the iframe should take the full width of its parent
//                                 height="700px"
//                                 style={{
//                                     position: 'absolute',
//                                     top: '-94px', // adjust this to push the iframe content up, hiding the header
//                                     border: 'none',
//                                     zIndex: 5
//                                 }}
//                             />
//                             <div style={{
//                                 position: 'absolute',
//                                 width: '100%', // ensure the overlay takes the full width
//                                 height: '90px', // height of the header you want to hide
//                                 bottom: '80px', // aligned to the bottom of the parent div
//                                 background: 'white',
//                                 zIndex: 10
//                             }} />
//                         </>
//                     )}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default LmiaCheck;

// LmiaCheck.tsx
import React from 'react';

const LmiaCheck: React.FC = () => {
    return (
        <div style={{ position: 'relative', width: '100%', height: '720px', overflow: 'hidden', display: 'flex', justifyContent: 'center' }}>
            <iframe
                src="https://fastcheck-lmia.vercel.app/"
                title="FastCheck: LMIAs"
                width="100%" // the iframe should take the full width of its parent
                height="760px"
                style={{
                    position: 'absolute',
                    top: '-94px', // adjust this to push the iframe content up, hiding the header
                    // border: 'none',
                    // zIndex: 5
                }}
            />
            {/* <div style={{
                position: 'absolute',
                width: '100%', // ensure the overlay takes the full width
                height: '90px', // height of the header you want to hide
                bottom: '80px', // aligned to the bottom of the parent div
                background: 'white',
                zIndex: 10
            }} /> */}
        </div>
    );
};

export default LmiaCheck;

// // EmbedPage.tsx
// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// const EmbedPage: React.FC = () => {
//   const navigate = useNavigate();

//   return (
//     <div>
//       <iframe
//         src="https://lmia.knnect.com/"
//         title="Embedded Content"
//         width="100%"
//         height="700px"
//         style={{
//           position: 'relative',
//           top: '-95px',
//           border: 'none',
//           zIndex: 5
//         }}
//       />
//       <div style={{
//         position: 'absolute',
//         width: '100%',
//         height: '100px',
//         bottom: '80px',
//         background: 'white',
//         zIndex: 10
//       }} />
//       <button onClick={() => navigate('/')} style={{
//         position: 'absolute',
//         top: '10px',
//         left: '10px',
//         zIndex: 20,
//       }}>
//         Go Back
//       </button>
//     </div>
//   );
// };

// export default EmbedPage;
